<nz-form-label [attr.nzFor]="formFieldInfo.fieldCode" [hidden]="hideTitle" nzNoColon>
    <span>{{name}} <span *ngIf="formFieldInfo.isRequired" style="color:red;">(*)</span></span>
    <app-component-tooltip [formFieldInfo]="fieldDataInfo"></app-component-tooltip>
</nz-form-label>
<nz-form-control [formGroup]="formGroup">
    <input style="width:100%" nz-input type="text" [id]="formFieldInfo.fieldCode" nzSize="large"
        (change)="onchangeNumberCurrencyField($event)" (keyup)="onchangeNumberCurrencyField($event)" [value]="value"
        [formControlName]="formFieldInfo.fieldCode" [(ngModel)]="defaultValue" (ngModelChange)="modelChange()" />
    <div class="text-muted">{{text}}</div>
    <div class="text-muted">{{textEN}}</div>
</nz-form-control>